import { render, staticRenderFns } from "./QrcodePay.vue?vue&type=template&id=30c21d8d"
import script from "./QrcodePay.vue?vue&type=script&lang=js"
export * from "./QrcodePay.vue?vue&type=script&lang=js"
import style0 from "./QrcodePay.vue?vue&type=style&index=0&id=30c21d8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports